<template>
    <main id="checklist-join-event-wrapper">
        <div id="checklist-join-event-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url + '/', status: false },
                    { title: 'HCID', url: app_url + '/hcid', status: true }
                ]"
            ></breadcrumb>
            <div class="container-fluid title-row">
                <div class="container py-5">
                    <h2>Checklist Join Event</h2>
                </div>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div
                        v-if="loaderevent"
                        class="loading loading-double"
                    ></div>
                    <div v-else class="col-md-12">
                        <div class="row py-4">
                            <div class="col">
                                <a :href="app_url + '/hcid'">
                                    <img
                                        :src="
                                            cdn_url +
                                                '/assets/community/images/arrow-back.png'
                                        "
                                        alt="img-arrow"
                                        class="img-arrow"
                                    />
                                    <span class="px-2 text-back"
                                        >Kembali ke HCID</span
                                    >
                                </a>
                            </div>
                        </div>
                        <div v-if="events.length > 0">
                            <div
                                class="row py-3"
                                v-for="(event, index) in events"
                                :key="index"
                            >
                                <div class="col">
                                    <div class="card">
                                        <div class="card-body">
                                            <div
                                                class="row align-items-center content-wrapper"
                                            >
                                                <!-- <img v-if="event.status == 0" :src="base_url+'/images/check.png'" alt="img-check" class="img-check px-3"> -->
                                                <img
                                                    v-if="event.status == 1"
                                                    :src="
                                                        cdn_url +
                                                            '/assets/community/images/check-blue.png'
                                                    "
                                                    alt="img-check"
                                                    class="img-check px-3"
                                                />
                                                <img
                                                    v-else
                                                    :src="
                                                        cdn_url +
                                                            '/assets/community/images/check.png'
                                                    "
                                                    alt="img-check"
                                                    class="img-check px-3"
                                                />
                                                <div class="col event-desc">
                                                    <div class="inner-desc">
                                                        <span
                                                            class="date-event"
                                                            >{{
                                                                event.start_date
                                                            }}</span
                                                        >
                                                        <h3>
                                                            {{ event.name }}
                                                        </h3>
                                                        <div
                                                            v-if="event.payment"
                                                            class="payment-event"
                                                            v-show="
                                                                event.type.toLowerCase() ===
                                                                    'hbd-nasional'
                                                            "
                                                        >
                                                            <div>
                                                                Status
                                                                Pembayaran
                                                                Starter Kit:
                                                                <span
                                                                    v-if="
                                                                        event
                                                                            .payment
                                                                            .status ===
                                                                            'SUCCESS'
                                                                    "
                                                                    class="success"
                                                                    >Berhasil</span
                                                                >
                                                                <span
                                                                    v-else
                                                                    class="failed"
                                                                    >Belum
                                                                    Berhasil</span
                                                                >
                                                            </div>
                                                            <div>
                                                                Metode
                                                                Pembayaran:
                                                                <span
                                                                    v-if="
                                                                        event
                                                                            .payment
                                                                            .payment_type ===
                                                                            'virtual_account'
                                                                    "
                                                                    class="payment-method"
                                                                    >Virtual
                                                                    Account</span
                                                                >
                                                                <span
                                                                    v-else-if="
                                                                        event
                                                                            .payment
                                                                            .payment_type ===
                                                                            'qris'
                                                                    "
                                                                    class="payment-method"
                                                                    >QRIS</span
                                                                >
                                                                <span
                                                                    v-else-if="
                                                                        event
                                                                            .payment
                                                                            .payment_type ===
                                                                            'ewallet'
                                                                    "
                                                                    class="payment-method"
                                                                    >E-Wallet</span
                                                                >
                                                                <span
                                                                    v-else
                                                                    class="payment-method"
                                                                    >Bayar di
                                                                    Tempat</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-if="event.payment"
                                                        class="inner-invoice"
                                                        v-show="
                                                            event.type.toLowerCase() ===
                                                                'hbd-nasional' &&
                                                                event.payment
                                                                    .status ===
                                                                    'SUCCESS'
                                                        "
                                                    >
                                                        <div
                                                            class="wrapper-button"
                                                        >
                                                            <a
                                                                @click="
                                                                    showPopupInvoice(
                                                                        event
                                                                    )
                                                                "
                                                                class="btn btn-red"
                                                                >Lihat Bukti
                                                                Pembayaran</a
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="messagebox">
                            <h4>Kamu Belum Join Event Apapun</h4>
                            <br />
                            <a
                                :href="app_url + '/event'"
                                class="btn btn-primary"
                                >Cari event di sini</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <EventInvoicePopup
                ref="invoicePopup"
                @close="showInvoice = !showInvoice"
            />
        </transition>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import EventInvoicePopup from "../event/EventInvoicePopup.vue";

export default {
    components: {
        breadcrumb: BreadCrumb,
        EventInvoicePopup
    },
    data() {
        return {
            cdn_url: cdn_url,
            base_url: "",
            app_url: "",
            api_url: "",
            mobile: false,
            events: [],
            user: null,
            token: null,
            loaderevent: true,
            showInvoice: false
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if (localStorage.getItem("user") != null) {
            this.user = JSON.parse(localStorage.getItem("user"));
        }
        if (localStorage.getItem("token") != null) {
            this.token = localStorage.getItem("token");
        }
        this.getEvent();
    },
    methods: {
        // GTM Tracker
        checklistJoinEventTracker(eventList) {
            const tracker = {
                event: "checkListJoinEvent",
                "eventDetail.category": "Custom Event",
                "eventDetail.action": "Check List Join Event",
                "eventDetail.label": "Profile HCID",
                eventList: this.generateEventList(eventList)
            };
            console.log(tracker);
            dataLayer.push(tracker);
        },
        generateEventList(events) {
            const eventList = events.map(event => {
                return {
                    eventName: event.name || "",
                    eventType: event.type || "",
                    month: event.month || "",
                    province: event.province || ""
                };
            });
            return eventList;
        },
        // End of GTM Tracker
        getEvent() {
            axios
                .get(api_url + "/member/event/attend", {
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    }
                })
                .then(response => {
                    console.log(response);
                    this.events = response.data.data.event;
                    this.checklistJoinEventTracker(this.events);
                    this.loaderevent = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        showPopupInvoice(event) {
            this.$refs.invoicePopup.openInvoice(event);
        }
    }
};
</script>

<style scoped lang="scss">
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 200ms ease-out;
}

#checklist-join-event-page {
    background: #000000;

    .card {
        background: #191919;
        border-radius: 10px;
        color: #ffffff;
        padding: 20px;
        margin-bottom: 15px;
    }

    .title-row {
        background: #191919;
        opacity: 0.95;
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #ffffff;
    }

    .img-arrow {
        max-width: 20px;
    }

    .img-check {
        max-height: 25px;
    }

    .text-back {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #ffffff;
    }

    .event-desc {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .inner-desc {
            .date-event {
                color: #b4b4b4;
                font-size: 14px;
                font-weight: 300;
            }

            h3 {
                margin-top: 5px;
            }

            .payment-event {
                display: flex;
                align-items: center;

                div {
                    font-size: 16px;
                    font-weight: 300;

                    .payment-method {
                        font-weight: 500;
                    }

                    .failed {
                        color: #e61b33;
                        font-weight: 500;
                    }

                    .success {
                        color: #42cf00;
                        font-weight: 500;
                    }

                    &:first-child {
                        padding-right: 10px;
                        border-right: 1px solid #ffffff;
                    }

                    &:last-child {
                        padding-left: 10px;
                    }
                }
            }
        }

        .inner-invoice {
            margin-left: 20px;
            white-space: nowrap;
        }
    }

    @media (max-width: 768px) {
        .card {
            padding: 15px;
            margin-bottom: 10px;
        }

        .content-wrapper {
            flex-wrap: nowrap !important;
        }

        .img-arrow {
            max-width: 18px;
        }

        .img-check {
            max-height: 20px;
        }

        .text-back {
            font-size: 12px;
        }

        .event-desc {
            flex-direction: row;
            align-items: flex-start;
            flex-wrap: wrap;

            .inner-desc {
                margin-bottom: 10px;
                width: 100%;

                .date-event {
                    font-size: 12px;
                }

                h3 {
                    font-size: 20px;
                }

                .payment-event {
                    flex-direction: column;
                    align-items: start;
                    margin-top: 10px;
                    width: 100%;

                    div {
                        padding: 0;
                        border: none;
                        margin-bottom: 5px;
                        font-size: 14px;

                        &:first-child {
                            border-right: none;
                            padding-right: 0;
                            padding-bottom: 10px;
                            border-bottom: 1px solid #fff;
                        }

                        &:last-child {
                            padding-left: 0;
                        }
                    }
                }
            }

            .inner-invoice {
                width: 100%;
                margin-left: 0;
                text-align: left;
            }
        }

        .title-row {
            font-size: 28px;
            line-height: 36px;
        }
    }
}
</style>
